import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'

import { reportWebVitals } from '@percent/utility'
import { EnvironmentOverlay } from '@percent/shared/environment-overlay'
import { AppRoutes } from '@percent/education-hosted-form/routing/AppRoutes'
import { AppProviders } from '@percent/education-hosted-form/providers/AppProviders'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

function App() {
  return (
    <StrictMode>
      <AppProviders>
        <EnvironmentOverlay />
        <AppRoutes />
      </AppProviders>
    </StrictMode>
  )
}

root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
